/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_9366f74f .ms-Suggestions-itemButton{padding:0px;border:none}.callout_9366f74f .ms-Suggestions{width:300px}\n"}]);
export const callout = "callout_9366f74f";